// api/login.js
import { http } from "./http";

export default async function login(user, password) {
  const url = `${process.env.REACT_APP_SERVER}/auth/login`;

  const data = await http(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user, password }),
    // opcional: timeout específico pro login
    timeoutMs: 15000,
  });

  // validação de contrato (ainda faz sentido ficar aqui)
  if (!data?.token) {
    // pode ser ApiError também, mas aqui é "contrato inválido"
    throw new Error("Resposta inválida do servidor (token ausente).");
  }

  return data;
}
